// src/components/MultiSelectPermissions.js
import React from "react";
import { Form } from "react-bootstrap";

const MultiSelectPermissions = ({ permissions, selectedPermissions, onChange }) => {

  const handleCheckbox = (id) => {
    if (selectedPermissions.includes(id)) {
      onChange(selectedPermissions.filter((p) => p !== id));
    } else {
      onChange([...selectedPermissions, id]);
    }
  };

  return (
    <div className="d-flex flex-wrap">
      {permissions.map((perm) => (
        <Form.Check
          key={perm.id}
          type="checkbox"
          id={`perm-${perm.id}`}
          label={perm.permission_name}
          checked={selectedPermissions.includes(perm.id)}
          onChange={() => handleCheckbox(perm.id)}
          className="me-3 mb-2"
        />
      ))}
    </div>
  );
};

export default MultiSelectPermissions;
